import React, {
  useState,
  useEffect,
  useRef,
  useContext,
  useCallback,
  Suspense,
} from "react";
import $ from "jquery";
import { Link } from "react-router-dom";
import {
  addUpdateEmployeeKeyValue,
  deleteEmployeeAccount,
  UpdateOfficialEmail,
} from "./Service/profileService";
import { getTrans as T } from "../../../Shared/Language";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import { getRawPermissionsArray } from "../../../Routes/AuthGard/usePermissions";
import {
  getEmployeeKeys,
  getEmployeeList,
  getEmployeeListDetailsByGUID,
} from "../EmployeeList/Service/employeeService";
import { useFormik } from "formik";
import * as Yup from "yup";
import { LoaderContext } from "../../../Services/Loader_Provider_Service/LoadingContext";
import { LazyImage } from "../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import EmployeeActivities from "./CommonComponents/EmployeeActivities";
import Badges from "./CommonComponents/Badges";
import UserEducationDetails from "./CommonComponents/UserEducationDetails";
import UserAward from "./CommonComponents/UserAward";
import UserExperience from "./CommonComponents/UserExperience";
import KudosAndApreciation from "./CommonComponents/KudosAndApreciation";
import BasicInfo from "./CommonComponents/BasicInfo";
import AlternativeContactInfo from "./CommonComponents/AlternativeContactInfo";
import OrganizationInfo from "./CommonComponents/OrganizationInfo";
import EmployeeGallery from "./CommonComponents/EmployeeGallery";
import moment from "moment";
import Certificate from "./CommonComponents/Certificate";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader";
import { TostMsg } from "../../../App";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { useDispatch } from "react-redux";
import {
  setLeaveRequestData,
  setMessageRequestData,
} from "../../../Services/Redux/DataTransferToAnother";
import { postEmployeeFollow } from "../Dashboard/Services/DashboardServices";
import { Image } from "primereact/image";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import RelationshipInfo from "./CommonComponents/RelationshipInfo";
import SalaryAccount from "./CommonComponents/SalaryAccount";
import AddressInfo from "./CommonComponents/AddressInfo";
import Statutory from "./CommonComponents/Statutory";
import UserMedia from "./CommonComponents/UserMedia";
import { Button } from "primereact/button";
import UserSkillAndLanguage from "./CommonComponents/UserSkillAndLanguage";
import UserRolePermission from "./CommonComponents/UserRolePermission";
import ImageCropperModal from "../../../Services/Comment/ImageCropperModal";
import { uploadDoc } from "../../../Services/Global-Services/GlobalServices";
import TeamReportOrHierarchy from "./CommonComponents/TeamReportOrHierarchy";
import UploadFile_KEYS from "../../../Services/Global-Services/UploadFile_Keys";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import { Dialog } from "primereact/dialog";

function UserProfile() {
  const dispatch = useDispatch();
  const { UserId } = useParams();
  const [employeeTeam, setEmployeeTeam] = useState([]);
  const [employee, setEmployee] = useState([]);
  const [employeeId, setEmployeeId] = useState(0);
  const [employeeBasicDetails, setEmployeeBasicDetails] = useState([]);
  const toster = useContext(TostMsg);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  // const { showLoading, hideLoading } = useContext(LoaderContext);
  const [Isloading, setIsloading] = useState(false);
  const [description, setDescription] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const defaultImage = "/images/placeholder_profile.png";
  let userPermissions = getRawPermissionsArray();
  const [updateProfile, setUpdateProfile] = useState(false);
  const [update, setUpdate] = useState(false);
  const [deleted, setDeleted] = useState(false);
  const history = useHistory();
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const [employeeKeyDeta, setEmployeeKeyDeta] = useState([]);
  const [disDataId, setDisDataId] = useState();
  const [hirechyDataList, setHirechy] = useState();
  const [show, setShow] = useState(true);
  const [OfficialEmailId, setOfficialEmailId] = useState();
  const [exitStatus, setExitStatus] = useState(false);
  const [chatRead, setChatRead] = useState(false);
  const [acceptRatio, setAcceptRatio] = useState(0);
  const [showCropper, setShowCropper] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const [isImageloading, setIsImageloading] = useState(false);
  const inputFile = useRef(null);
  const [emailHeader, setEmailHeader] = useState([]);
  const [emailText, setEmailText] = useState([]);
  const [accountHeader, setAccountHeader] = useState([]);
  const [accountText, setAccountText] = useState([]);
  const [initiateHeader, setInitiateHeader] = useState([]);
  const [initiateText, setInitiateText] = useState([]);
  const [isExitPopupOpen, setExitPopupOpen] = useState(false);
  const [visible, setVisible] = useState(false);
  const [teamHeader, setTeamHeader] = useState([]);
  const [emailValid, setEmailValid] = useState("");
  const handleUpdateEmployeeDetails = (newData) => {
    fetchEmployeeIdData();
  };

  const toggleDiv = () => {
    setShow(!show);
  };

  const handleCloseClick = () => {
    setIsEditing(false);
  };

  const handleChangeDescription = (e) => {
    setDescription(e.target.value);
  };
  function Lastprop() {
    $(".last-prop").click(function () {
      $(".hidetime").slideToggle();
    });
  }
  useEffect(() => {
    GetMasterSystemAlertList("View_Hierarchy", 2);
    GetMasterSystemAlertList("Header_Email", 3);
    GetMasterSystemAlertList("Text_Email", 4);
    GetMasterSystemAlertList("AccountDelete_Header", 5);
    GetMasterSystemAlertList("EmployeeDelete_Message", 6);
    GetMasterSystemAlertList("Confirmation_Dialog_Title", 7);
    GetMasterSystemAlertList("Confirmation_Dialog_Body", 8);
    getEmployeeKeysData();
    Lastprop();
  }, []);

  useEffect(() => {
    if (UserId) {
      fetchEmployeeIdData();
    }
  }, [UserId]);

  useEffect(() => {
    if (employeeId) {
      permissionAccouncement();
      HierarchyList();
    }
  }, [employeeId]);

  useEffect(() => {
    setIsloading(true);
    if (employee?.length > 0) {
      const basicDetails = employee[0]?.EmpKeyValues?.filter((item) => {
        return item;
      });
      setEmployeeBasicDetails(basicDetails);
      setIsloading(false);
    }
  }, [employee]);

  const permissionAccouncement = () => {
    if (userDetails?.EmpId == employeeId) {
      setUpdate(true);
      setDeleted(true);
    } else {
      setIsloading(false);
    }

    userPermissions?.map((UserPermission) => {
      if (UserPermission.PermissionName == "Employee.Create") {
        setUpdateProfile(true);
      }
      if (UserPermission.PermissionName == "Exit.Manage") {
        setExitStatus(true);
      }
      if (UserPermission.PermissionName == "Chat.Read") {
        setChatRead(true);
      }
    });
  };

  async function editProfile(profileDetails) {
    history.push(`/Employee/Edit/${UserId}`);
  }

  async function editIntroduction(profileInfo) {
    setDisDataId(profileInfo);
    setIsEditing(true);
    const requestDes = profileInfo?.Value || "";
    setDescription(requestDes);
  }

  async function editIntroData() {
    setIsloading(true);
    let param = [
      {
        EmpId: disDataId?.EmpId,
        KeyId: disDataId?.KeyId,
        Value: description,
        Text: disDataId?.Value,
      },
    ];
    try {
      let res = await addUpdateEmployeeKeyValue(param);
      fetchEmployeeIdData();
      setIsEditing(false);
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
    }
  }

  //For get the employee data.
  async function fetchEmployeeIdData() {
    setIsloading(true);
    var params = {
      GUID: UserId,
    };
    try {
      let employeesList = await getEmployeeListDetailsByGUID(params);
      setEmployee([employeesList.Data]);
      setEmployeeId(employeesList.Data?.EmpId);
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
    }
  }

  async function deleteAccounId() {
    let body = {
      Id: employee[0]?.Id,
    };
    try {
      setIsloading(false);
      let employeesList = await deleteEmployeeAccount(body);
      GetMasterSystemAlertList("SignOut_message", 0);
      if (userDetails?.EmpId === employee[0]?.Id) {
        localStorage.clear();
        if (localStorage.length >= 0) {
          history.push("/");
        }
      } else {
        history.push("/TeamDirectory");
      }
    } catch (error) {
      setIsloading(false);
    }
  }

  async function HierarchyList(data) {
    var params1 = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 2,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 1000,
      EmployeeId: employeeId,
      IsSuggestedOnly: 0,
    };
    try {
      let hierarchyList = await getEmployeeList(params1);
      setHirechy(hierarchyList.Data);
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
    }
  }
  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        setTeamHeader(msg?.Desc);
      } else if (msg?.Name == message && type == 3) {
        setEmailHeader(msg?.Desc);
      } else if (msg?.Name == message && type == 4) {
        setEmailText(msg?.Desc);
      } else if (msg?.Name == message && type == 5) {
        setAccountHeader(msg?.Desc);
      } else if (msg?.Name == message && type == 6) {
        setAccountText(msg?.Desc);
      } else if (msg?.Name == message && type == 7) {
        setInitiateHeader(msg?.Desc);
      } else if (msg?.Name == message && type == 8) {
        setInitiateText(msg?.Desc);
      }
    });
  }, []);

  function updateCurrentList() {
    const CurrentEmploye = { EmpId: employeeId, GUID: UserId };
    dispatch(setLeaveRequestData(CurrentEmploye));
  }

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  async function PostEmployeeFollow(Id) {
    let params = {
      FollowerId: userDetails?.EmpId,
      EmpId: Id,
    };
    const updatedEmployeeTeamFollowStatus = employeeTeam?.map((emp) =>
      emp.EmpId === Id
        ? { ...emp, IsFollowed: emp.IsFollowed === 0 ? 1 : 0 }
        : emp,
    );
    try {
      await postEmployeeFollow(params);
      setEmployeeTeam(updatedEmployeeTeamFollowStatus);
      fetchEmployeeIdData();
    } catch (error) {
      toster.current.error(ERROR_LIST.DefaultError);
    }
  }

  const scrollToKudos = () => {
    const el = document.getElementById("kudos-section");
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  function capitalizeWords(str) {
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  }

  async function getEmployeeKeysData() {
    try {
      let employeeKeys = await getEmployeeKeys();
      setEmployeeKeyDeta(employeeKeys.Data);
    } catch (error) {
      toster.current.error(ERROR_LIST.DefaultError);
    }
  }

  const changePassward = () => {
    history.push(`/ChangePassword`);
  };

  const SetPassward = () => {
    history.push(`/SetPassword`);
  };

  const exitInitiate = () => {
    if (!employee[0]?.IsInitiatedExit) {
      setExitPopupOpen(true);
    } else {
      const exitGUID = employee[0]?.ExitRequest.GUID;
      history.push(`/Employee/Exit/${exitGUID}`);
    }
  };

  const continueInitiateExit = () => {
    setExitPopupOpen(false);
    history.push(`/Exit/Initiate/${employee[0].GUID}`);
  };

  const handleInitiateCloseModal = () => {
    setExitPopupOpen(false);
  };

  const emailValidation = Yup.object().shape({
    email: Yup.string()
      .transform((value) => value.trim())
      .required("Email is required.")
      .email("Email is invalid."),
  });

  async function editEmail(editEmailDetails) {
    let myModal = new window.bootstrap.Modal(
      document.getElementById("edit-Email"),
    );
    myModal.show();
    if (editEmailDetails) {
      setOfficialEmailId(editEmailDetails.Id);
      const editEmailDetailsData = {
        EmpId: editEmailDetails.Id,
        email: editEmailDetails?.UserName,
        OrgId: editEmailDetails?.OrgId,
      };
      emailFrom.setValues(editEmailDetailsData);
    }
  }

  async function deleteAccountEmployee() {
    let myModal = new window.bootstrap.Modal(
      document.getElementById("delete-account"),
    );
    myModal.show();
  }

  const emailFrom = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: emailValidation,
    onSubmit: async (data) => {
      setIsloading(true);
      const params = {
        EmpId: data?.EmpId,
        OrgId: userDetails.OrgId,
        OfficialEmail: data?.email?.toLocaleLowerCase(),
      };
      try {
        const res = await UpdateOfficialEmail(params);
        if (res?.StatusCode === 2000) {
          setEmailValid("");
          document.querySelector("#edit-Email .btn-close")?.click();
          GetMasterSystemAlertList("Updated_official_email", 0);
        } else {
          setEmailValid(res?.Message);
        }
        if (userDetails?.EmpId === employee[0]?.Id) {
          setVisible(true);
        }
        fetchEmployeeIdData();
        setIsloading(false);
      } catch (error) {
        setIsloading(false);
        toster.current.error(ERROR_LIST.DefaultError);
      } finally {
        setIsloading(false);
      }
    },
  });

  const handleCloseModal = () => {
    setEmailValid("");
    document.querySelector("#edit-Email .btn-close")?.click();
    emailFrom.resetForm();
  };

  const handleLogout = () => {
    setVisible(false);
    GetMasterSystemAlertList("SignOut_message", 0);
    localStorage.clear();
    if (localStorage.length >= 0) {
      history.push("/");
    }
  };

  useEffect(() => { }, [showCropper]);

  const handleFileChange = async (event, type) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setImageSrc(reader.result);
        setShowCropper(true);
        setAcceptRatio(1 / 1);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleCropComplete = (croppedBlob) => {
    uploadDocFile([
      new File([croppedBlob], "cropped.jpg", { type: "image/jpeg" }),
    ]);
  };

  async function uploadDocFile(file) {
    setIsImageloading(true);
    setIsloading(true);
    if (file) {
      const formData = new FormData();
      for (let i = 0; i < file.length; i++) {
        formData.append("files", file[i]);
      }
      let params = {
        UploadType: UploadFile_KEYS?.User_profile,
        RefId: employeeId ?? 0,
      };
      try {
        const response = await uploadDoc(params, formData);
        const data = await response;
        const ImageURL = data?.Data;
        if (ImageURL) {
          userDetails.ProfileImage = ImageURL[0];
          localStorage.setItem("User", JSON.stringify(userDetails));
          let imageKeyId = employeeKeyDeta.filter((item) => item.OEKId === 104);
          const params = [
            {
              EmpId: userDetails?.EmpId,
              KeyId: imageKeyId[0]?.KeyId,
              Text: "",
              Value: ImageURL[0],
            },
          ];
          let formSaveAndContinue = await addUpdateEmployeeKeyValue(params);
          if (formSaveAndContinue) {
            toster.current.success("Profile updated successfully");
            fetchEmployeeIdData();
          }
        }
        setIsImageloading(false);
        setIsloading(false);
      } catch (error) {
        setIsImageloading(false);
        setIsloading(false);
        toster.current.error(ERROR_LIST.UploadFileError);
      } finally {
      }
    } else {
      setIsImageloading(false);
      setIsloading(false);
      toster.current.warn("No file selected");
    }
  }

  const redirectToAnotherPage = (employee) => {
    dispatch(setMessageRequestData(employee));
    history.push(`/Messages`);
  };

  const contact = employee[0]?.Contacts?.find(
    (c) => c.ContactTypeId === 104 && c.Contact,
  );

  const email = employee[0]?.Contacts?.find(
    (c) => c.ContactTypeId === 101 && c.Contact,
  );

  return (
    <div>
      <div className="profile-module">
        {Isloading ? (
          <Skeleton height={60} width="100%" />
        ) : (
          <div className="top-section-profile">
            <div className="row">
              <div className="media-flex-center mb-0">
                <div className="d-flex  profile-top-area ">
                  {showCropper && imageSrc && (
                    <ImageCropperModal
                      image={imageSrc}
                      onCropComplete={handleCropComplete}
                      onClose={() => setShowCropper(false)}
                      acceptRatio={acceptRatio}
                    />
                  )}
                  {employee[0]?.EmpId === userDetails?.EmpId ? (
                    <>
                      <div className="h-avatar is-large">
                        <Image
                          className="avatar"
                          src={
                            employeeBasicDetails?.find(
                              (data) => data?.OEKId === 104,
                            )?.InferredValue || defaultImage
                          }
                          onError={handleImageError}
                          data-demo-src="/images/placeholder_profile.png"
                          width="250"
                          preview
                        />
                        <div
                          className="p-image-file-upload"
                          style={{ cursor: "pointer" }}
                        >
                          <i className="fa fa-camera upload-button"></i>
                          <input
                            ref={inputFile}
                            className="file-upload"
                            type="file"
                            accept="image/png, image/gif, image/jpeg"
                            onChange={(event) => handleFileChange(event, 0)}
                          />
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      {employeeBasicDetails?.find(
                        (data) => data?.OEKId === 104,
                      ) ? (
                        <div className="h-avatar is-large">
                          <Image
                            className="avatar"
                            src={
                              employeeBasicDetails?.find(
                                (data) => data?.OEKId === 104,
                              )?.InferredValue || defaultImage
                            }
                            onError={handleImageError}
                            data-demo-src="/images/placeholder_profile.png"
                            width="250"
                            preview
                          />
                        </div>
                      ) : (
                        <div className="h-avatar is-large">
                          <Image
                            className="avatar"
                            src="/images/placeholder_profile.png"
                            onError={handleImageError}
                            data-demo-src="/images/placeholder_profile.png"
                            width="250"
                            preview
                          />
                        </div>
                      )}
                    </>
                  )}
                  <div className="flex-meta">
                    <span>
                      {employee[0]?.FullName}
                      {updateProfile && (
                        <span
                          onClick={() => {
                            editProfile(employee[0]);
                            GetMasterSystemAlertList("Update_personal_info", 1);
                          }}
                          className="editprofile-admin"
                          title="Edit"
                        >
                          <LazyImage
                            src="/images/org-img/edit.png"
                            className="w-100"
                          />
                        </span>
                      )}
                      {updateProfile && (
                        <span
                          onClick={() => editEmail(employee[0])}
                          className="editprofile-admin"
                          title="Edit Official Email"
                        >
                          <img
                            src="/images/org-img/editEmail.png"
                            style={{ width: "20px" }}
                          />
                        </span>
                      )}
                      {updateProfile && (
                        <span className="editprofile-admin">
                          <svg
                            onClick={() => deleteAccountEmployee()}
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            title="Deelet Account"
                            className="bi bi-person-slash"
                            viewBox="0 0 16 16"
                          >
                            <title>Account Delete</title>
                            <path d="M13.879 10.414a2.501 2.501 0 0 0-3.465 3.465zm.707.707-3.465 3.465a2.501 2.501 0 0 0 3.465-3.465m-4.56-1.096a3.5 3.5 0 1 1 4.949 4.95 3.5 3.5 0 0 1-4.95-4.95ZM11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0M8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m.256 7a4.5 4.5 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10q.39 0 .74.025c.226-.341.496-.65.804-.918Q8.844 9.002 8 9c-5 0-6 3-6 4s1 1 1 1z" />
                          </svg>
                        </span>
                      )}
                       {(userDetails?.EmpId !== employeeId && chatRead) && (
                        <span className="editprofile-admin chat">
                          <svg
                            onClick={() => redirectToAnotherPage(employee)}
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-chat-text"
                            viewBox="0 0 16 16"
                          >
                            <title>Chat</title>
                            <path d="M2.678 11.894a1 1 0 0 1 .287.801 11 11 0 0 1-.398 2c1.395-.323 2.247-.697 2.634-.893a1 1 0 0 1 .71-.074A8 8 0 0 0 8 14c3.996 0 7-2.807 7-6s-3.004-6-7-6-7 2.808-7 6c0 1.468.617 2.83 1.678 3.894m-.493 3.905a22 22 0 0 1-.713.129c-.2.032-.352-.176-.273-.362a10 10 0 0 0 .244-.637l.003-.01c.248-.72.45-1.548.524-2.319C.743 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7-3.582 7-8 7a9 9 0 0 1-2.347-.306c-.52.263-1.639.742-3.468 1.105" />
                            <path d="M4 5.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8m0 2.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5" />
                          </svg>
                        </span>
                      )}
                    </span>

                    <span>
                      {
                        employeeBasicDetails?.find(
                          (data) => data?.OEKId === 121,
                        )?.InferredValue
                      }
                    </span>
                    <div className="employee-div d-flex flex-wrap">
                      {employeeBasicDetails?.map(
                        (data) =>
                          data?.OEKId === 112 && (
                            <span>
                              {data.KeyDesc} - {data.InferredValue}
                            </span>
                          ),
                      )}
                      {contact && (
                        <>
                          <span className="spancl"></span>
                          {employee[0]?.Code}
                          {contact.Contact}
                        </>
                      )}
                      {email && (
                        <>
                          <span className="spancl"></span>
                          {email.Contact}
                        </>
                      )}
                    </div>
                    <div className="profile-since-date">
                      <span>
                        Associate Since -{" "}
                        {moment(employee[0]?.DateOfJoining).format(
                          "MMM DD YYYY",
                        )}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="btn-follow-un">
                  <div className="profile-user-box">
                    <div className="profile-col-area text-right ">
                      {userDetails?.EmpId !== employeeId && (
                        <a
                          className="edit-btncss love-icon me-1"
                          data-toggle="tooltip"
                          data-placement="top"
                        >
                          {employee[0]?.FollowersCount != 0 &&
                            employee[0]?.IsFollowed == 1 ? (
                            <div
                              onClick={() => PostEmployeeFollow(employeeId)}
                              className="follow-unfollow-member"
                              style={{ cursor: "pointer" }}
                              title="UnFollow"
                            >
                              <div className="image">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  style={{
                                    color: "#ffffff",
                                    background: " #671cc9",
                                  }}
                                  fill="currentColor"
                                  className="bi bi-hand-thumbs-down-fill"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M6.956 14.534c.065.936.952 1.659 1.908 1.42l.261-.065a1.38 1.38 0 0 0 1.012-.965c.22-.816.533-2.512.062-4.51q.205.03.443.051c.713.065 1.669.071 2.516-.211.518-.173.994-.68 1.2-1.272a1.9 1.9 0 0 0-.234-1.734c.058-.118.103-.242.138-.362.077-.27.113-.568.113-.856 0-.29-.036-.586-.113-.857a2 2 0 0 0-.16-.403c.169-.387.107-.82-.003-1.149a3.2 3.2 0 0 0-.488-.9c.054-.153.076-.313.076-.465a1.86 1.86 0 0 0-.253-.912C13.1.757 12.437.28 11.5.28H8c-.605 0-1.07.08-1.466.217a4.8 4.8 0 0 0-.97.485l-.048.029c-.504.308-.999.61-2.068.723C2.682 1.815 2 2.434 2 3.279v4c0 .851.685 1.433 1.357 1.616.849.232 1.574.787 2.132 1.41.56.626.914 1.28 1.039 1.638.199.575.356 1.54.428 2.591" />
                                </svg>
                              </div>
                            </div>
                          ) : (
                            <>
                              <div
                                onClick={() => PostEmployeeFollow(employeeId)}
                                className="follow-unfollow-member"
                                style={{ cursor: "pointer" }}
                                title="Follow"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  className="bi bi-hand-thumbs-up-fill"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M6.956 1.745C7.021.81 7.908.087 8.864.325l.261.066c.463.116.874.456 1.012.965.22.816.533 2.511.062 4.51a10 10 0 0 1 .443-.051c.713-.065 1.669-.072 2.516.21.518.173.994.681 1.2 1.273.184.532.16 1.162-.234 1.733q.086.18.138.363c.077.27.113.567.113.856s-.036.586-.113.856c-.039.135-.09.273-.16.404.169.387.107.819-.003 1.148a3.2 3.2 0 0 1-.488.901c.054.152.076.312.076.465 0 .305-.089.625-.253.912C13.1 15.522 12.437 16 11.5 16H8c-.605 0-1.07-.081-1.466-.218a4.8 4.8 0 0 1-.97-.484l-.048-.03c-.504-.307-.999-.609-2.068-.722C2.682 14.464 2 13.846 2 13V9c0-.85.685-1.432 1.357-1.615.849-.232 1.574-.787 2.132-1.41.56-.627.914-1.28 1.039-1.639.199-.575.356-1.539.428-2.59z" />
                                </svg>
                              </div>
                            </>
                          )}
                        </a>
                      )}
                      <a
                        onClick={() => scrollToKudos()}
                        className="edit-btncss love-icon me-1"
                        title="Appreciate"
                      >
                        <LazyImage
                          src="/images/org-img/profile/heart.png"
                          className=""
                        />
                      </a>
                    </div>
                    <div className="profile-col-rt-area">
                      <div>
                        {/* {employee[0]?.FollowersCount != 0 && ( */}
                        <Link
                          to={employee[0]?.FollowersCount != 0 && `/Followers/${employee[0]?.GUID}`}
                          onClick={() => updateCurrentList()}
                          className="edit-btncss"
                        >
                          <b>{employee[0]?.FollowersCount}</b> Followers
                        </Link>
                        {/* )} */}
                        {/* {employee[0]?.FollowingCount != 0 && ( */}
                        <Link
                          to={employee[0]?.FollowingCount != 0 && `/Followings/${employee[0]?.GUID}`}
                          className="edit-btncss"
                          onClick={() => updateCurrentList()}
                        >
                          <b>{employee[0]?.FollowingCount}</b> Followings
                        </Link>
                        {/* )} */}
                        {employee[0]?.Posts != 0 && (
                          <Link to={`/Feed/User/${UserId}`}>
                            <a className="edit-btncss">
                              <b>{employee[0]?.Posts}</b> {T("Posts")}
                            </a>
                          </Link>
                        )}
                        {employeeBasicDetails
                          ?.filter(
                            (data) =>
                              data.KeyCategoryId === 103 &&
                              data.OEKId !== 121 &&
                              data.OEKId !== 112 &&
                              data.OEKId !== 104,
                          )
                          .sort((a, b) => a.KeyDisplayOrder - b.KeyDisplayOrder)
                          .map((data) => (
                            <>
                              {data.InferredValue != "" &&
                                data.InferredValue != null && (
                                  <a className="disable-btncss" key={data.Id}>
                                    {data.KeyDesc} <b>{data.InferredValue}</b>
                                  </a>
                                )}
                            </>
                          ))}
                      </div>
                      <div className="d-flex mt-2"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="detailed-section-profile">
          <div className="row">
            {Isloading ? (
              <Skeleton height={60} width="100%" />
            ) : (
              <div className="col-md-8">
                <div className="card">
                  <div className="card-body">
                    <div className="account-box is-navigation">
                      <div className="custom-tab-1">
                        <ul className="nav nav-tabs">
                          <li className="nav-item">
                            <a
                              href="#my-posts"
                              data-bs-toggle="tab"
                              className="nav-link show active"
                            >
                              Profile
                            </a>
                          </li>
                          <li className="nav-item">
                            <a
                              href="#team"
                              data-bs-toggle="tab"
                              className="nav-link"
                            >
                              Team
                            </a>
                          </li>
                          {(update || updateProfile) && (
                            <li className="nav-item">
                              <a
                                href="#account"
                                data-bs-toggle="tab"
                                className="nav-link"
                              >
                                Salary Account
                              </a>
                            </li>
                          )}
                          {(update || updateProfile) && (
                            <li className="nav-item">
                              <a
                                href="#document"
                                data-bs-toggle="tab"
                                className="nav-link"
                              >
                                Address
                              </a>
                            </li>
                          )}
                          {(update || updateProfile) && (
                            <li className="nav-item">
                              <a
                                href="#statutory"
                                data-bs-toggle="tab"
                                className="nav-link"
                              >
                                Statutory
                              </a>
                            </li>
                          )}
                          {/* {update && updateProfile && (
                            <li className="nav-item">
                              <a
                                href="#role_Permission"
                                data-bs-toggle="tab"
                                className="nav-link"
                              >
                                Role & Permission
                              </a>
                            </li>
                          )} */}
                        </ul>

                        <div className="tab-content mt-3">
                          <div
                            id="my-posts"
                            className="tab-pane fade active show"
                          >
                            <div className="profile-about-me timeline-item">
                              <div className="border-bottom-1">
                                <div className="mb-0 position-relative">
                                  <h4 className="text-primary mb-2 sumh4 addprofile-action">
                                    Introduction
                                  </h4>
                                  {employeeBasicDetails?.map(
                                    (data) =>
                                      data.KeyName == "About" && (
                                        <>
                                          {update && (
                                            <>
                                              {!isEditing ? (
                                                <img
                                                  style={{
                                                    position: "absolute",
                                                    right: "0",
                                                    top: "0",
                                                  }}
                                                  onClick={() =>
                                                    editIntroduction(data)
                                                  }
                                                  src="/images/org-img/edit.png"
                                                  title="Edit"
                                                  className="side-pen-icon"
                                                  data-bs-toggle="modal"
                                                />
                                              ) : (
                                                <>
                                                  <div className="des-edit-icons">
                                                    <img
                                                      onClick={handleCloseClick}
                                                      src="/images/org-img/profile/close.png"
                                                      title="Cancel"
                                                      className=""
                                                      data-bs-toggle="modal"
                                                    />
                                                    <img
                                                      src="/images/org-img/profile/check.png"
                                                      title="Confirm"
                                                      onClick={() => {
                                                        editIntroData();
                                                      }}
                                                      className=""
                                                      data-bs-toggle="modal"
                                                    />
                                                  </div>
                                                </>
                                              )}
                                            </>
                                          )}

                                          {isEditing ? (
                                            <>
                                              <textarea
                                                name="Description"
                                                className={"form-control mb-4"}
                                                onChange={
                                                  handleChangeDescription
                                                }
                                                value={description}
                                                rows="10"
                                                cols="1"
                                                maxLength={500}
                                              ></textarea>
                                              <div
                                                style={{
                                                  textAlign: "right",
                                                  fontSize: "12px",
                                                  // position: "absolute",
                                                  // right: "27px",
                                                  bottom: "1px",
                                                  color:
                                                    description?.length >= 500
                                                      ? "red"
                                                      : "#555",
                                                }}
                                              >
                                                {description?.length || 0}/500
                                              </div>
                                            </>
                                          ) : (
                                            <>
                                              <p className="text-black">
                                                {data.InferredValue}{" "}
                                              </p>
                                            </>
                                          )}
                                        </>
                                      ),
                                  )}

                                  {employeeBasicDetails
                                    ?.filter(
                                      (data) =>
                                        data.KeyCategoryId == 104 &&
                                        data?.OEKId != 105,
                                    )
                                    .sort(
                                      (a, b) =>
                                        a.KeyDisplayOrder - b.KeyDisplayOrder,
                                    )
                                    .map((data) => (
                                      <>
                                        {data.InferredValue != "" &&
                                          data.InferredValue != null && (
                                            <ul
                                              className="tag-ul1"
                                              key={data.Id}
                                            >
                                              <li>
                                                <img src={data.Icon} />
                                                {data?.KeyDesc} &nbsp;
                                                <b>{data.InferredValue}</b>
                                              </li>
                                            </ul>
                                          )}
                                      </>
                                    ))}

                                  <ul className="tag-ul1">
                                    {employee[0]?.DirectReporteeCount ? (
                                      <li>
                                        <img src="/images/org-img/profile/members.svg" />
                                        Manages &nbsp;
                                        <b
                                          style={{ cursor: "pointer" }}
                                          onClick={() => {
                                            const tabTriggerEl =
                                              document.querySelector(
                                                'a[href="#team"]',
                                              );
                                            if (tabTriggerEl) {
                                              const tab =
                                                new window.bootstrap.Tab(
                                                  tabTriggerEl,
                                                );
                                              tab.show();
                                            }
                                          }}
                                          className="btn-link"
                                        >
                                          {employee[0]?.DirectReporteeCount - 1}
                                          + members
                                        </b>
                                      </li>
                                    ) : (
                                      ""
                                    )}
                                  </ul>
                                </div>
                              </div>
                            </div>{" "}
                          </div>
                          <div id="team" className="tab-pane fade">
                            <TeamReportOrHierarchy
                              employeeId={employeeId}
                              employee={employee}
                            />
                          </div>
                          <div id="account" className="tab-pane fade">
                            {employee.length > 0 && (
                              <SalaryAccount
                                employeeAllData={employee}
                                employeeKeyDeta={employeeKeyDeta}
                                updateEmployeeDetails={
                                  handleUpdateEmployeeDetails
                                }
                              />
                            )}
                          </div>
                          <div id="document" className="tab-pane fade">
                            <AddressInfo
                              employeeId={employeeId}
                              employee={employee}
                              updateEmployeeDetails={
                                handleUpdateEmployeeDetails
                              }
                            />
                          </div>
                          <div id="statutory" className="tab-pane fade">
                            {employee.length > 0 && (
                              <Statutory
                                employeeAllData={employee}
                                employeeKeyDeta={employeeKeyDeta}
                                updateEmployeeDetails={
                                  handleUpdateEmployeeDetails
                                }
                              />
                            )}
                          </div>
                          <div id="role_Permission" className="tab-pane fade">
                            <UserRolePermission
                              employeeId={employeeId}
                              employee={employee}
                              updateEmployeeDetails={
                                handleUpdateEmployeeDetails
                              }
                            />
                          </div>
                          <EmployeeActivities
                            employee={employee}
                            employeeId={employeeId}
                          />
                          <Badges employee={employee} employeeId={employeeId} />
                          <UserExperience
                            employee={employee}
                            employeeId={employeeId}
                            fetchEmployeeIdData={fetchEmployeeIdData}
                          />
                          <UserEducationDetails
                            employee={employee}
                            employeeId={employeeId}
                            fetchEmployeeIdData={fetchEmployeeIdData}
                          />
                          <UserSkillAndLanguage
                            employee={employee}
                            employeeId={employeeId}
                            fetchEmployeeIdData={fetchEmployeeIdData}
                          />
                          <UserAward
                            employeeId={employeeId}
                            employee={employee}
                          />
                          <Certificate
                            employee={employee}
                            employeeId={employeeId}
                          />
                          <div id="kudos-section">
                            <KudosAndApreciation
                              UserId={employeeId}
                              employeeId={employeeId}
                              fetchEmployeeIdData={fetchEmployeeIdData}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {Isloading ? (
              <Skeleton height={60} width="100%" />
            ) : (
              <div className="col-md-4" id="info">
                <div className="col-xl-12">
                  <div className="card">
                    <div className="card-body">
                      <div className="contact-mandivs00">
                        <a className="timeline-panel text-muted profiledrop d-flex">
                          <h6 className="profiledropul-prof2">
                            {userDetails?.EmpId != employeeId ? (
                              <>
                                {" "}
                                <span> {employee[0]?.FirstName}</span>
                                's Reporting Manager
                              </>
                            ) : (
                              <>Your Reporting Manager</>
                            )}

                            <b>
                              {employee[0]?.OverseerName
                                ? employee[0]?.OverseerName
                                : "N/A"}
                            </b>
                          </h6>
                          {hirechyDataList?.length > 0 && (
                            <div className="last-prop" onClick={toggleDiv}>
                              <img
                                src="/images/org-img/profile/time.png"
                                className="w-100"
                                alt="time"
                              />
                            </div>
                          )}
                        </a>
                      </div>
                      {show && (
                        <div className="hidetime">
                          {hirechyDataList?.some(
                            (report) => report?.FullName,
                          ) && (
                              <div className="form-head stuck-headers hidetime mb-0 mt-2 mb-3">
                                <div className="form-head stuck-header profile-about-me">
                                  <span className="direct-r">Direct Reports</span>
                                  <div className="icon-timeline mt-3">
                                    {hirechyDataList
                                      .slice(0, 4)
                                      ?.map((report, index) => {
                                        return (
                                          report?.FullName && (
                                            <div
                                              className="timeline-item"
                                              key={index}
                                            >
                                              <div className="timeline-icon is-squared">
                                                <LazyImage
                                                  className="avatar"
                                                  src={report?.ProfileImage}
                                                />
                                              </div>
                                              <div className="timeline-content">
                                                <Link
                                                  to={`/Profile/${report?.GUID}`}
                                                >
                                                  <p
                                                    style={{
                                                      color: "rgb(78, 168, 222)",
                                                    }}
                                                  >
                                                    {report?.FullName
                                                      ? capitalizeWords(
                                                        report.FullName,
                                                      )
                                                      : ""}
                                                  </p>
                                                </Link>
                                                <span>
                                                  {report?.CurrentDepartment ? (
                                                    <>
                                                      {report?.CurrentDepartment}
                                                    </>
                                                  ) : (
                                                    "N/A"
                                                  )}
                                                </span>
                                              </div>
                                            </div>
                                          )
                                        );
                                      })}
                                  </div>
                                  <div className="timeline-content ms-0">
                                    <a
                                      className="add-newticket w-auto mt-3"
                                      onClick={() => {
                                        const tabTriggerEl =
                                          document.querySelector(
                                            'a[href="#team"]',
                                          );
                                        if (tabTriggerEl) {
                                          const tab = new window.bootstrap.Tab(
                                            tabTriggerEl,
                                          );
                                          tab.show();
                                        }
                                      }}
                                    >
                                      {teamHeader}
                                    </a>
                                  </div>
                                </div>
                              </div>
                            )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-xl-12">
                  <div className="card">
                    <div className="card-body">
                      <UserMedia
                        employeeAllData={employee}
                        employeeKeyDeta={employeeKeyDeta}
                        employeeId={employeeId}
                        updateEmployeeDetails={handleUpdateEmployeeDetails}
                      />
                    </div>
                  </div>
                </div>
                {employeeBasicDetails?.some(
                  (report) => report?.KeyCategoryId === 101,
                ) && (
                    <div className="col-xl-12">
                      <div className="card">
                        <div className="card-body">
                          <BasicInfo
                            EmployeeBasicDetails={employeeBasicDetails}
                            employeeAllData={employee}
                            employeeKeyDeta={employeeKeyDeta}
                            employeeId={employeeId}
                            updateEmployeeDetails={handleUpdateEmployeeDetails}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                {employeeBasicDetails?.some(
                  (report) => report?.KeyCategoryId === 102,
                ) && (
                    <div className="col-xl-12">
                      <div className="card">
                        <div className="card-body">
                          <RelationshipInfo
                            EmployeeBasicDetails={employeeBasicDetails}
                            employeeAllData={employee}
                            employeeKeyDeta={employeeKeyDeta}
                            employeeId={employeeId}
                            updateEmployeeDetails={handleUpdateEmployeeDetails}
                          />
                        </div>
                      </div>
                    </div>
                  )}

                {employeeBasicDetails?.some(
                  (report) => report?.KeyCategoryId === 103,
                ) && (
                    <div className="col-xl-12">
                      <div className="card">
                        <div className="card-body">
                          <OrganizationInfo
                            employeeId={employeeId}
                            EmployeeBasicDetails={employeeBasicDetails}
                          />
                        </div>
                      </div>
                    </div>
                  )}

                <div className="col-xl-12">
                  <div className="card">
                    <div className="card-body">
                      <EmployeeGallery
                        employee={employee}
                        employeeId={employeeId}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-xl-12">
                  <div className="card">
                    <div className="card-body">
                      <AlternativeContactInfo
                        employee={employee}
                        employeeId={employeeId}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-xl-12">
                  <div className="profile-action-buttons">
                    {(exitStatus ||
                      userDetails?.EmpId === employee[0]?.EmpId) && (
                        <button onClick={() => exitInitiate()} type="button">
                          {employee[0]?.IsInitiatedExit
                            ? "Exit Details"
                            : "Initiate Exit"}
                        </button>
                      )}
                    {userDetails?.EmpId == employeeId && (
                      <>
                        {userDetails?.IsPasswordSet == true ? (
                          <button onClick={() => changePassward()}>
                            Change Password
                          </button>
                        ) : (
                          <button onClick={() => SetPassward()}>
                            Set Password
                          </button>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div
        className="modal fade custom-modal-area"
        id="edit-Email"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content add-editbadge add-editexperience">
            <div className="modal-header">
              <img
                src="/images/org-img/leave/popup-backimg.png"
                className="backimg"
              />
              <div className="img">
                <img src="/images/popup-icons/featured-post.png" />
              </div>
              <button
                onClick={handleCloseModal}
                type="button"
                className="btn-close m-auto"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body ">
              <h5 className="modal-title text-center">{emailHeader}</h5>
              <p className="text-center">{emailText}</p>
              <div className="addcourseform">
                <form onSubmit={emailFrom.handleSubmit}>
                  <div className="row">
                    <div className="mb-4 col-md-12 mt-3">
                      <label className="form-label">
                        Email Id
                        <i className="inValidError">*</i>
                      </label>
                      <div className="">
                        <input
                          type="text"
                          cols="1"
                          rows="4"
                          name="email"
                          className={
                            "form-control" +
                            (emailFrom.errors.email && emailFrom.touched.email
                              ? " is-invalid"
                              : "")
                          }
                          onChange={(e) => {
                            emailFrom.setFieldValue(
                              "email",
                              e.target.value.trimStart(),
                            );
                            setEmailValid("");
                          }}
                          value={emailFrom.values.email}
                          placeholder="Enter Your Email"
                        />
                      </div>
                      <div className="invalid-feedback">
                        {emailFrom.errors.email && emailFrom.touched.email
                          ? emailFrom.errors.email
                          : null}
                      </div>{" "}
                      {emailValid && (
                        <div className="invalid-feedback">{emailValid}</div>
                      )}
                    </div>
                  </div>
                  <div className="modal-footer m-auto justify-content-center">
                    <button
                      type="button"
                      className="cancelbtn-click"
                      data-bs-dismiss="modal"
                      onClick={handleCloseModal}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="savebtn-click"
                      disabled={Isloading}
                    >
                      {Isloading ? "Please wait..." : "Update"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card flex justify-content-center">
        <Dialog visible={visible} closable={false}>
          <div className="custom-modal-area logout-user">
            <div className="modal-content add-editbadge add-editexperience">
              <div className="modal-header">
                <img
                  src="/images/org-img/leave/popup-backimg.png"
                  className="backimg"
                />
                <div className="img">
                  <img src="/images/popup-icons/featured-post.png" />
                </div>
              </div>
              <div className="modal-body text-center">
                <strong className="modal-title">
                  <h5 className="modal-title m-auto">
                    Your Updated Official Email
                  </h5>
                </strong>
                {/* {employee[0]?.Contacts?.map(
                (contact) =>
                  contact.ContactTypeId == 101 &&
                  contact.Contact && <p>{contact.Contact}</p>
              )} */}
                <p>{employee[0]?.UserName}</p>
                <div className="addcourseform">
                  <div className="row">
                    <div className="mb-4 col-md-12 mt-3">
                      <label className="form-label">
                        Please log out and log in again to apply the changes.
                      </label>
                    </div>
                  </div>
                  <div className="modal-footer m-auto justify-content-center">
                    <button
                      type="submit"
                      className="savebtn-click"
                      onClick={handleLogout}
                    >
                      Logout
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Dialog>
      </div>
      <div
        className="modal fade "
        id="delete-account"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content delete-holiday">
            <div className="modal-header">
              <img
                src="/images/org-img/leave/popup-backimg.png"
                className="backimg"
              />
              <div className="img">
                <img src="/images/org-img/leave/trash.png" />
              </div>
            </div>
            <div className="modal-body text-center">
              <h3 className="modal-title">{accountHeader} </h3>
              <p>{accountText}</p>
            </div>
            <div className="modal-footer m-auto">
              <button
                type="button"
                className="cancelbtn-click"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="deletebtn-click"
                data-bs-dismiss="modal"
                onClick={() => deleteAccounId()}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
      {isExitPopupOpen && (
        <div
          className="modal fade custom-modal-area show initiate-confirmation-area"
          id="initiate-confirmation-popup"
          tabIndex="-1"
          aria-hidden="true"
          style={{ display: "block" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content add-editbadge add-editexperience">
              <div className="modal-header">
                <img
                  src="/images/org-img/leave/popup-backimg.png"
                  className="backimg"
                />
                <div className="img">
                  <img src="/images/popup-icons/featured-post.png" />
                </div>
                <button
                  onClick={handleInitiateCloseModal}
                  type="button"
                  className="btn-close m-auto"
                  data-bs-dismiss="modal"
                ></button>
              </div>
              <div className="modal-body ">
                <h5 className="modal-title text-center">{initiateHeader}</h5>
                <p>{initiateText}</p>

                <div className="modal-footer m-auto justify-content-center">
                  <button
                    type="button"
                    className="cancelbtn-click"
                    data-bs-dismiss="modal"
                    onClick={handleInitiateCloseModal}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="savebtn-click"
                    onClick={continueInitiateExit}
                  >
                    Yes, Continue to Resign
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}{" "}
      {Isloading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
}
export default UserProfile;
